import { Users, Calendar, Headset } from "lucide-react";
import { useNavigationContext } from "@/contexts/navigation";
import { Link } from "react-router-dom";

export function BookingSection() {
    const { bookingSectionRef } = useNavigationContext();

    return (
        <section ref={bookingSectionRef} className="py-16 bg-gradient-card">
            <div className="container mx-auto px-6 text-center">
                <div className="max-w-3xl mx-auto">
                    <h2 className="text-3xl md:text-4xl font-bold mb-6 text-foreground">
                        Väx tillsammans med andra
                    </h2>
                    <p className="text-xl text-muted-foreground mb-8 leading-relaxed">
                        Bli en del av en community där du utvecklas, utmanas och får stöd.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                        <style>{`
@keyframes small-ping {
  75%, 100% {
    transform: scale(1.5);
    opacity: 0;
  }
}`}
                        </style>
                        <div className="text-center">
                            <Link
                                to="https://daretolive.se/schema/"
                                target="_blank"
                                className="relative size-24 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4"
                            >
                                <div className="pointer-events-none absolute size-[100%] border-4 border-accent/10 rounded-full animate-[small-ping_2s_ease-in-out_infinite]" />
                                <Calendar className="w-8 h-8 text-accent" />
                            </Link>
                            <h3 className="text-lg font-semibold mb-2">Boka klasser</h3>
                            <p className="text-muted-foreground text-sm">Allt hänger ihop. Allt börjar i kroppen.</p>
                        </div>

                        <div className="text-center flex flex-col">
                            <Link
                                to="https://daretolive.se/test-talk/"
                                target="_blank"
                                className="relative size-24 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4"
                            >
                                <div className="pointer-events-none absolute size-[100%] border-4 border-success/10 rounded-full animate-[small-ping_2s_ease-in-out_infinite]" />
                                <Headset className="w-8 h-8 text-success" />
                            </Link>

                            <h3 className="text-lg font-semibold mb-2">Boka ett Test-talk</h3>
                            <p className="text-muted-foreground text-sm">Ditt stöd i vardagen både med teknik och det personliga.</p>
                        </div>

                        <div className="text-center flex flex-col">
                            <Link
                                to="https://daretolive.se/events/"
                                target="_blank"
                                className="relative size-24 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4"
                            >
                                <div className="pointer-events-none absolute size-[100%] border-4 border-accent/10 rounded-full animate-[small-ping_2s_ease-in-out_infinite]" />
                                <Users className="w-8 h-8 text-accent" />
                            </Link>

                            <h3 className="text-lg font-semibold mb-2">Boka event</h3>
                            <p className="text-muted-foreground text-sm">The Game changer - Upplev energin, möt andra och ta din utveckling till nästa nivå.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}